import { render } from "./SortArrowDownIcon.vue?vue&type=template&id=30263fd9"
const script = {}

import exportComponent from "/codebuild/output/src860361777/src/isi_presenter_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__